import { CodeBook } from "@king-ict/eupisi-ui/models/Common/CodeBook";
import { getI18n } from "react-i18next";

import { GenderEnum } from "../models/Shared/GenderEnum";
import { ServiceResultStatus } from "../models/Shared/OibServiceResult";
import OtherParentDataCheckStatusEnum from "../models/Shared/OtherParentDataCheckStatusEnum";

export const saveSuccess = "saveOK";

export const getOibErrorMessage = (
  serviceResult: ServiceResultStatus
): string => {
  const i18 = getI18n();
  var result = "";
  if (serviceResult === ServiceResultStatus.Unknown)
    result += i18.t("common.oibServiceResultStatus.unknown") + "\n";
  if (
    (serviceResult & ServiceResultStatus.Success) ===
    ServiceResultStatus.Success
  )
    result += i18.t("common.oibServiceResultStatus.success") + "\n";
  if (
    (serviceResult & ServiceResultStatus.OibFailed) ===
    ServiceResultStatus.OibFailed
  )
    result += i18.t("common.oibServiceResultStatus.oibFailed") + "\n";
  if (
    (serviceResult & ServiceResultStatus.BirthRegistryFailed) ===
    ServiceResultStatus.BirthRegistryFailed
  )
    result += i18.t("common.oibServiceResultStatus.birthRegistryFailed") + "\n";
  if (
    (serviceResult & ServiceResultStatus.MupFailed) ===
    ServiceResultStatus.MupFailed
  )
    result += i18.t("common.oibServiceResultStatus.mupFailed") + "\n";
  if (
    (serviceResult & ServiceResultStatus.OibExists) ===
    ServiceResultStatus.OibExists
  )
    result += i18.t("common.oibServiceResultStatus.oibExists") + "\n";
  if (
    (serviceResult & ServiceResultStatus.OibNotValid) ===
    ServiceResultStatus.OibNotValid
  )
    result += i18.t("common.oibServiceResultStatus.oibNotValid") + "\n";
  if (
    (serviceResult & ServiceResultStatus.AddressNotFound) ===
    ServiceResultStatus.AddressNotFound
  )
    result += i18.t("common.oibServiceResultStatus.addressNotFound") + "\n";
  if (
    (serviceResult & ServiceResultStatus.OibExistsInSchoolCandidate) ===
    ServiceResultStatus.OibExistsInSchoolCandidate
  )
    result +=
      i18.t("common.oibServiceResultStatus.oibExistsInSchoolCandidate") + "\n";
  if (
    (serviceResult & ServiceResultStatus.DataMismatch) ===
    ServiceResultStatus.DataMismatch
  )
    result += i18.t("common.oibServiceResultStatus.dataMismatch") + "\n";
  return result;
  /*   switch (serviceResult) {
    case ServiceResultStatus.Unknown:
      return ("common.oibServiceResultStatus.unknown");
    case ServiceResultStatus.OibFailed:
      return ("common.oibServiceResultStatus.oibFailed");
    case ServiceResultStatus.BirthRegistryFailed:
      return ("common.oibServiceResultStatus.birthRegistryFailed");
    case ServiceResultStatus.MupFailed:
      return ("common.oibServiceResultStatus.mupFailed");
    case ServiceResultStatus.OibExists:
      return ("common.oibServiceResultStatus.oibExists");
    case ServiceResultStatus.OibNotValid:
      return ("common.oibServiceResultStatus.oibNotValid");
    case ServiceResultStatus.AddressNotFound:
      return ("common.oibServiceResultStatus.addressNotFound");
    case ServiceResultStatus.OibExistsInSchoolCandidate:
      return ("common.oibServiceResultStatus.oibExistsInSchoolCandidate");
    default:
      return ("common.oibServiceResultStatus.success"); 
  }
 */
};

export const getSexString = (sex: GenderEnum | undefined): string => {
  switch (sex) {
    case GenderEnum.Male:
      return "gender.Male";
    case GenderEnum.Female:
      return "gender.Female";
    default:
      return "";
  }
};

export const getEnumToCodeBook = <TEnum extends {}>(
  type: TEnum,
  enumName: string
): CodeBook[] => {
  const i18 = getI18n();
  const arrayObjects = [] as CodeBook[];
  for (const [propertyKey, propertyValue] of Object.entries(type)) {
    var num = Number.parseInt(propertyKey);
    if (isNaN(num)) {
      continue;
    }
    var transKey = enumName + "." + propertyValue;
    var trans = i18.t(transKey);
    var codeBook = { id: num, name: trans } as CodeBook;
    arrayObjects.push(codeBook);
  }
  return arrayObjects.sort((a, b) => a.id - b.id);
};

export const getOtherParentValidationMessage = (
  serviceResult: OtherParentDataCheckStatusEnum
): string => {
  switch (serviceResult) {
    case OtherParentDataCheckStatusEnum.Unknown:
      return "common.oibServiceResultStatus.unknown";
    case OtherParentDataCheckStatusEnum.OibFailed:
      return "common.oibServiceResultStatus.oibFailed";
    case OtherParentDataCheckStatusEnum.BirthRegistryFailed:
      return "common.oibServiceResultStatus.birthRegistryFailed";
    case OtherParentDataCheckStatusEnum.MupFailed:
      return "common.oibServiceResultStatus.mupFailed";
    case OtherParentDataCheckStatusEnum.OibExists:
      return "common.oibServiceResultStatus.oibExists";
    case OtherParentDataCheckStatusEnum.OibNotValid:
      return "common.oibServiceResultStatus.oibNotValid";
    case OtherParentDataCheckStatusEnum.OibExistsInSchoolCandidate:
      return "common.oibServiceResultStatus.oibExistsInSchoolCandidate";
    case OtherParentDataCheckStatusEnum.DataMismatch:
      return "common.oibServiceResultStatus.dataMismatch";
    case OtherParentDataCheckStatusEnum.NoCustody:
      return "common.oibServiceResultStatus.noCustody";
    case OtherParentDataCheckStatusEnum.SameAsApplicantParent:
      return "common.oibServiceResultStatus.sameAsApplicantParent";
    default:
      return "common.oibServiceResultStatus.success";
  }
};
